import { HttpClientModule, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MyScores } from 'src/models/myscores.model';
//import { Player, PlayerList } from 'src/models/player.model';

@Injectable({
   providedIn: 'root',
})
export class PlayerService {

   constructor(private http: HttpClient) { }

   playerList(): Observable<any> {
      return this.http.get<any>(`/api/playerapi/playerlist`);
   }
   getScores(): Observable<MyScores> {
      return this.http.get<MyScores>('/api/playerapi');
   }

}

